// import { Marker } from 'react-leaflet';

// import useZoomLevel from './useZoomLevel'; // Путь к вашему хуку useZoomLevel

// const MarkersViewing = ({ data, icon, layersVisibilityCommunications, isLineDrawing, flag,
//   openModalWithContent, statusModalTerritory, highwayFlag, cantonFlag, position}) => {
  
//   const zoomLevel = useZoomLevel();
   
//   return (
//     <>
//       {data.map((item, index) => {
//         const eventHandlers = {};
//         if (!isLineDrawing && !flag) {
//           eventHandlers.click = () => {
//             let content = '';
//             if (statusModalTerritory === 'highway') {
//               content = highwayFlag;
//             } else if (statusModalTerritory === 'canton') {
//               content = cantonFlag;
//             }
//             openModalWithContent(item, content);
//           };
//         }

//         if (zoomLevel <= 16) {
//           return null;
//         }

//         return (
//           layersVisibilityCommunications && (
//             <Marker
//               key={index}
//               position={[item.latitude, item.longitude]}
//               icon={icon}
//               eventHandlers={{
//                 click: eventHandlers.click,
//               }}
//             />
//           )
//         );
//       })}
//     </>
//   );
// }

// export default MarkersViewing;



import { Marker } from 'react-leaflet';
import useZoomLevel from './useZoomLevel'; 
import { useState, useRef } from 'react';
import { UpdateWellCoordinate } from '../UpdateData/UpdateCommunications';
import { CONST_HIGHWAY, CONST_CANTON, WELL } from '../Constants/ConstantsOptics';
import ShowEditingCoorComponent from '../Drawing/ShowEditingCoorComponent';

const MarkersViewing = ({ data, icon, layersVisibilityCommunications, isLineDrawing, flag,
  openModalWithContent, statusModalTerritory, highwayFlag, cantonFlag, type, user, cantonRefresh,
  highwayRefresh, isComponentChangeCoor, setIsComponentChangeCoor, showPonLayer, showKtvLayer, showEtherLayer}) => {


 

    const zoomLevel = useZoomLevel();
    const newCoordinates = useRef({}); 
  
    const handleMarkerDragEnd = (event, id) => {
      if (!isComponentChangeCoor) return; 
    
      const { lat, lng } = event.target.getLatLng();
      newCoordinates.current = {};
      newCoordinates.current = { id, lat, lng, type };  
    };
  
    const handleSave = () => {
      const { id, lat, lng, type } = newCoordinates.current;
    
     if(type === WELL) {
      if (statusModalTerritory === CONST_HIGHWAY) {
        UpdateWellCoordinate(id, lat, lng, user, highwayRefresh);
      } else if (statusModalTerritory === CONST_CANTON) {
        UpdateWellCoordinate(id, lat, lng, user, cantonRefresh);
      }
    }else{
      console.log("Не определено ", type);
    }
  
      newCoordinates.current = {};
      setIsComponentChangeCoor(false); 
    };
  
    return (
      <>
        {data.map((item, index) => {

          const eventHandlers = {};
          if (!isLineDrawing && !flag) {
            eventHandlers.click = () => {
              let content = '';
              if (statusModalTerritory === CONST_HIGHWAY) {
                content = highwayFlag;
              } else if (statusModalTerritory === CONST_CANTON) {
                content = cantonFlag;
              }
              openModalWithContent(item, content);
            };
          }
  
          if (zoomLevel <= 16) {
            return null;
          }
  
          return (
            layersVisibilityCommunications && (
              (showPonLayer ? item.pon === 1 : true) && 
              (showKtvLayer ? item.ktv === 1 : true) && 
              (showEtherLayer ? item.ether === 1 : true) && 
              (
              <Marker
                key={index}
                position={[item.latitude, item.longitude]}
                icon={icon}
                draggable={isComponentChangeCoor} 
                eventHandlers={{
                  click: eventHandlers.click,
                  dragend: (event) => handleMarkerDragEnd(event, item.id), 
                }}
              />
            )
          )
          );
        })}
  
        {/* Компонент для сохранения или отмены изменений */}
        <ShowEditingCoorComponent
          isComponentChangeCoor={isComponentChangeCoor}
          setIsComponentChangeCoor={setIsComponentChangeCoor}
          handleSave={handleSave} 
        />
      </>
    );
  };
  
  export default MarkersViewing;